<template>
<div class="content-class">
	<v-tabs color="black" dark slider-color="primary">
		<v-tab ripple>Ajouter un utilisateur</v-tab>
	</v-tabs>
	<pro-user-form v-model="document">
	</pro-user-form>
</div>
</template>

<script>
import ProUserForm from '../../components/proUsers/proUser.form'

export default {
	components: { ProUserForm },
	data() {
		return {
			document: null
		}
	}
}
</script>

<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/proUsers/proUser.add.vue